import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../../auth/auth.service';
import { User } from '../../models/user';
import { UserService } from '../services/user.service';
import { getUserHomePage } from '../utils';

@Injectable({ providedIn: 'root' })
export class NotAuthGuard {
  private router = inject(Router);
  private userService = inject(UserService);
  private authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser = this.userService.getUser();
    if (!currentUser) {
      return true;
    }

    this.authService.syncSourceResourceAttribution(currentUser);

    if (currentUser.company_type === 'lender') {
      return this.handleLenderGuard(state, currentUser);
    }

    if (this.authService.shouldRedirectToCruOnboarding(currentUser)) {
      this.authService.redirectToCruOnboarding();
      return false;
    }

    this.router.navigate([getUserHomePage(currentUser)]);
    return false;
  }

  handleLenderGuard(state: RouterStateSnapshot, user: User): boolean {
    const isStripeCompleted = user.has_stripe_account && user.has_stripe_details_submitted;
    if (user.can_send_payments && isStripeCompleted) {
      this.router.navigate([getUserHomePage(user)]);
      return false;
    }
    return true;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(childRoute, state);
  }
}
